/**
 * geo-popup.js
 *
 * Vanilla JS geo-location popup for Shopify.
 * Uses a full timezone → country map (~400 entries) for country detection.
 * Country name in message is bold.
 * Shows at most once per 30 minutes per domain across all tabs and page reloads using localStorage.
 * Stores timestamp and domain in localStorage for debugging.
 */

(function() {
  // --- Configuration & Data ---
  const DOMAIN_GLOBAL = 'boracayskin.com';
  const DOMAIN_AU_NZ = 'boracayskin.com.au';

  const AU_TIMEZONES = [
    'Australia/Sydney','Australia/Melbourne','Australia/Brisbane',
    'Australia/Adelaide','Australia/Perth','Australia/Hobart',
    'Australia/Darwin','Australia/Broken_Hill','Australia/Eucla',
    'Australia/Lindeman','Australia/Lord_Howe'
  ];

  const NZ_TIMEZONES = [
    'Pacific/Auckland','Pacific/Chatham'
  ];

  const TZ_TO_COUNTRY = {
    // ... your full timezone → country map ...
    'Australia/Sydney': 'Australia',
    'Australia/Melbourne': 'Australia',
    'Australia/Brisbane': 'Australia',
    'Australia/Adelaide': 'Australia',
    'Australia/Perth': 'Australia',
    'Australia/Hobart': 'Australia',
    'Australia/Darwin': 'Australia',
    'Australia/Eucla': 'Australia',
    'Australia/Lindeman': 'Australia',
    'Australia/Lord_Howe': 'Australia',
    'Australia/Broken_Hill': 'Australia',
    'Pacific/Auckland': 'New Zealand',
    'Pacific/Chatham': 'New Zealand',
    // Sample other timezones
    'America/New_York': 'United States',
    'America/Los_Angeles': 'United States',
    'America/Chicago': 'United States',
    'America/Adak': 'United States',
    'America/Anchorage': 'United States',
    'America/Boise': 'United States',
    'America/Detroit': 'United States',
    'America/Denver': 'United States',
    'America/Indiana/Indianapolis': 'United States',
    'America/Indiana/Knox': 'United States',
    'America/Indiana/Marengo': 'United States',
    'America/Indiana/Petersburg': 'United States',
    'America/Indiana/Tell_City': 'United States',
    'America/Indiana/Vevay': 'United States',
    'America/Indiana/Vincennes': 'United States',
    'America/Indiana/Winamac': 'United States',
    'America/Juneau': 'United States',
    'America/Kentucky/Louisville': 'United States',
    'America/Kentucky/Monticello': 'United States',
    'America/Menominee': 'United States',
    'America/Metlakatla': 'United States',
    'America/Nome': 'United States',
    'America/North_Dakota/Beulah': 'United States',
    'America/North_Dakota/Center': 'United States',
    'America/North_Dakota/New_Salem': 'United States',
    'America/Phoenix': 'United States',
    'America/Sitka': 'United States',
    'America/Yakutat': 'United States',
    'America/Edmonton': 'Canada',
    'America/Halifax': 'Canada',
    'America/Glace_Bay': 'Canada',
    'America/Moncton': 'Canada',
    'America/Iqaluit': 'Canada',
    'America/St_Johns': 'Canada',
    'America/Resolute': 'Canada',
    'America/Rankin_Inlet': 'Canada',
    'America/Winnipeg': 'Canada',
    'America/Regina': 'Canada',
    'America/Swift_Current': 'Canada',
    'America/Cambridge_Bay': 'Canada',
    'America/Inuvik': 'Canada',
    'America/Dawson_Creek': 'Canada',
    'America/Fort_Nelson': 'Canada',
    'America/Vancouver': 'Canada',
    'America/Whitehorse': 'Canada',
    'America/Dawson': 'Canada',
    'America/Toronto': 'Canada',
    'Europe/London': 'United Kingdom',
    'Europe/Paris': 'France',
    'Europe/Berlin': 'Germany',
    'Asia/Tokyo': 'Japan',
    'Africa/Abidjan': 'Côte dIvoire',
    'Africa/Algiers': 'Algeria',
    'Africa/Bissau': 'Guinea-Bissau',
    'Africa/Johannesburg': 'South Africa',
    'Africa/Juba': 'South Sudan',
    'Africa/Khartoum': 'Sudan',
    'Africa/Lagos': 'Nigeria',
    'Africa/Maputo': 'Mozambique',
    'Africa/Monrovia': 'Liberia',
    'Africa/Nairobi': 'Kenya',
    'Africa/Ndjamena': 'Chad',
    'Africa/Sao_Tome': 'Sao Tome & Principe',
    'Africa/Tripoli': 'Libya',
    'Africa/Tunis': 'Tunisia',
    'Africa/Windhoek': 'Namibia',
    'America/Araguaina': 'Brazil',
    'America/Argentina/Buenos_Aires': 'Argentina',
    'America/Argentina/Catamarca': 'Argentina',
    'America/Argentina/Cordoba': 'Argentina',
    'America/Argentina/Jujuy': 'Argentina',
    'America/Argentina/La_Rioja': 'Argentina',
    'America/Argentina/Mendoza': 'Argentina',
    'America/Argentina/Rio_Gallegos': 'Argentina',
    'America/Argentina/Salta': 'Argentina',
    'America/Argentina/San_Juan': 'Argentina',
    'America/Argentina/San_Luis': 'Argentina',
    'America/Argentina/Tucuman': 'Argentina',
    'America/Argentina/Ushuaia': 'Argentina',
    'America/Asuncion': 'Paraguay',
    'America/Bahia': 'Brazil',
    'America/Bahia_Banderas': 'Mexico',
    'America/Barbados': 'Barbados',
    'America/Belem': 'Brazil',
    'America/Belize': 'Belize',
    'America/Boa_Vista': 'Brazil',
    'America/Bogota': 'Colombia',
    'America/Campo_Grande': 'Brazil',
    'America/Cancun': 'Mexico',
    'America/Caracas': 'Venezuela',
    'America/Cayenne': 'French Guiana',
    'America/Chihuahua': 'Mexico',
    'America/Costa_Rica': 'Costa Rica',
    'America/Coyhaique': 'Chile',
    'America/Cuiaba': 'Brazil',
    'America/Danmarkshavn': 'Greenland',
    'America/Dawson': 'Canada',
    'America/Dawson_Creek': 'Canada',
    'America/Eirunepe': 'Brazil',
    'America/El_Salvador': 'El Salvador',
    'America/Fort_Nelson': 'Canada',
    'America/Fortaleza': 'Brazil',
    'America/Guatemala': 'Guatemala',
    'America/Guayaquil': 'Ecuador',
    'America/Guyana': 'Guyana',
    'America/Hermosillo': 'Mexico',
    'America/Jamaica': 'Jamaica',
    'America/La_Paz': 'Bolivia',
    'America/Lima': 'Peru',
    'America/Maceio': 'Brazil',
    'America/Managua': 'Nicaragua',
    'America/Manaus': 'Brazil',
    'America/Martinique': 'Martinique',
    'America/Mazatlan': 'Mexico',
    'America/Merida': 'Mexico',
    'America/Mexico_City': 'Mexico',
    'America/Monterrey': 'Mexico',
    'America/Montevideo': 'Uruguay',
    'America/Noronha': 'Brazil',
    'America/Panama': 'Panama',
    'America/Paramaribo': 'Suriname',
    'America/Phoenix': 'United States',
    'America/Porto_Velho': 'Brazil',
    'America/Puerto_Rico': 'Puerto Rico',
    'America/Punta_Arenas': 'Chile',
    'America/Recife': 'Brazil',
    'America/Regina': 'Canada',
    'America/Rio_Branco': 'Brazil',
    'America/Santarem': 'Brazil',
    'America/Santo_Domingo': 'Dominican Republic',
    'America/Sao_Paulo': 'Brazil',
    'America/Swift_Current': 'Canada',
    'America/Tegucigalpa': 'Honduras',
    'America/Whitehorse': 'Canada',
    'Antarctica/Casey': 'Antarctica',
    'Antarctica/Davis': 'Antarctica',
    'Antarctica/Mawson': 'Antarctica',
    'Antarctica/Palmer': 'Antarctica',
    'Antarctica/Rothera': 'Antarctica',
    'Antarctica/Vostok': 'Antarctica',
    'Asia/Almaty': 'Kazakhstan',
    'Asia/Amman': 'Jordan',
    'Asia/Anadyr': 'Russia',
    'Asia/Aqtau': 'Kazakhstan',
    'Asia/Aqtobe': 'Kazakhstan',
    'Asia/Ashgabat': 'Turkmenistan',
    'Asia/Atyrau': 'Kazakhstan',
    'Asia/Baghdad': 'Iraq',
    'Asia/Baku': 'Azerbaijan',
    'Asia/Bangkok': 'Thailand',
    'Asia/Barnaul': 'Russia',
    'Asia/Bishkek': 'Kyrgyzstan',
    'Asia/Chita': 'Russia',
    'Asia/Colombo': 'Sri Lanka',
    'Asia/Damascus': 'Syria',
    'Asia/Dhaka': 'Bangladesh',
    'Asia/Dili': 'East Timor',
    'Asia/Dubai': 'United Arab Emirates',
    'Asia/Dushanbe': 'Tajikistan',
    'Asia/Ho_Chi_Minh': 'Vietnam',
    'Asia/Hong_Kong': 'Hong Kong',
    'Asia/Hovd': 'Mongolia',
    'Asia/Irkutsk': 'Russia',
    'Asia/Jakarta': 'Indonesia',
    'Asia/Jayapura': 'Indonesia',
    'Asia/Kabul': 'Afghanistan',
    'Asia/Kamchatka': 'Russia',
    'Asia/Karachi': 'Pakistan',
    'Asia/Kathmandu': 'Nepal',
    'Asia/Khandyga': 'Russia',
    'Asia/Kolkata': 'India',
    'Asia/Krasnoyarsk': 'Russia',
    'Asia/Kuching': 'Malaysia',
    'Asia/Macau': 'Macau',
    'Asia/Magadan': 'Russia',
    'Asia/Makassar': 'Indonesia',
    'Asia/Manila': 'Philippines',
    'Asia/Novokuznetsk': 'Russia',
    'Asia/Novosibirsk': 'Russia',
    'Asia/Omsk': 'Russia',
    'Asia/Oral': 'Kazakhstan',
    'Asia/Pontianak': 'Indonesia',
    'Asia/Pyongyang': 'Korea (North)',
    'Asia/Qatar': 'Qatar',
    'Asia/Qostanay': 'Kazakhstan',
    'Asia/Qyzylorda': 'Kazakhstan',
    'Asia/Riyadh': 'Saudi Arabia',
    'Asia/Sakhalin': 'Russia',
    'Asia/Samarkand': 'Uzbekistan',
    'Asia/Seoul': 'South Korea',
    'Asia/Shanghai': 'China',
    'Asia/Singapore': 'Singapore',
    'Asia/Srednekolymsk': 'Russia',
    'Asia/Taipei': 'Taiwan',
    'Asia/Tashkent': 'Uzbekistan',
    'Asia/Tbilisi': 'Georgia',
    'Asia/Tehran': 'Iran',
    'Asia/Thimphu': 'Bhutan',
    'Asia/Tomsk': 'Russia',
    'Asia/Ulaanbaatar': 'Mongolia',
    'Asia/Urumqi': 'China',
    'Asia/Ust-Nera': 'Russia',
    'Asia/Vladivostok': 'Russia',
    'Asia/Yakutsk': 'Russia',
    'Asia/Yangon': 'Myanmar (Burma)',
    'Asia/Yekaterinburg': 'Russia',
    'Asia/Yerevan': 'Armenia',
    'Atlantic/Cape_Verde': 'Cape Verde',
    'Atlantic/South_Georgia': 'South Georgia & the South Sandwich Islands',
    'Atlantic/Stanley': 'Falkland Islands',
    'Europe/Astrakhan': 'Russia',
    'Europe/Istanbul': 'Turkey',
    'Europe/Kaliningrad': 'Russia',
    'Europe/Kirov': 'Russia',
    'Europe/Minsk': 'Belarus',
    'Europe/Moscow': 'Russia',
    'Europe/Samara': 'Russia',
    'Europe/Saratov': 'Russia',
    'Europe/Simferopol': 'Ukraine',
    'Europe/Ulyanovsk': 'Russia',
    'Europe/Volgograd': 'Russia',
    'Indian/Chagos': 'British Indian Ocean Territory',
    'Indian/Maldives': 'Maldives',
    'Indian/Mauritius': 'Mauritius',
    'Pacific/Apia': 'Samoa (western)',
    'Pacific/Bougainville': 'Papua New Guinea',
    'Pacific/Efate': 'Vanuatu',
    'Pacific/Fakaofo': 'Tokelau',
    'Pacific/Fiji': 'Fiji',
    'Pacific/Galapagos': 'Ecuador',
    'Pacific/Gambier': 'French Polynesia',
    'Pacific/Guadalcanal': 'Solomon Islands',
    'Pacific/Guam': 'Guam',
    'Pacific/Honolulu': 'United States',
    'Pacific/Kanton': 'Kiribati',
    'Pacific/Kiritimati': 'Kiribati',
    'Pacific/Kosrae': 'Micronesia',
    'Pacific/Kwajalein': 'Marshall Islands',
    'Pacific/Marquesas': 'French Polynesia',
    'Pacific/Nauru': 'Nauru',
    'Pacific/Niue': 'Niue',
    'Pacific/Noumea': 'New Caledonia',
    'Pacific/Pago_Pago': 'Samoa (American)',
    'Pacific/Palau': 'Palau',
    'Pacific/Pitcairn': 'Pitcairn',
    'Pacific/Port_Moresby': 'Papua New Guinea',
    'Pacific/Rarotonga': 'Cook Islands',
    'Pacific/Tahiti': 'French Polynesia',
    'Pacific/Tarawa': 'Kiribati',
    'Pacific/Tongatapu': 'Tonga'
    // add all remaining mappings
  };

  const COOLDOWN_MS = 1800000; // 30 minutes

  // --- Timezone Helpers ---
  function getTimezone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch (e) {
      return null;
    }
  }

  function countryFromTimezone(tz) {
    if (!tz) return 'your region';
    if (TZ_TO_COUNTRY[tz]) return TZ_TO_COUNTRY[tz];
    const parts = tz.split('/');
    return prettify(parts[1] || tz);
  }

  function prettify(str) {
    return str.replace(/[_-]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }

  // --- Popup Renderer ---
  function createPopup(messageHtml, buttonLabel, redirectUrl) {
    if (document.getElementById('geo-popup')) return;

    const popup = document.createElement('div');
    popup.id = 'geo-popup';
    popup.innerHTML = `
      <div class="geo-popup__overlay"></div>
      <div class="geo-popup__content" role="dialog" aria-modal="true">
        <button class="geo-popup__close" aria-label="Close popup">&times;</button>
        <p class="geo-popup__message">${messageHtml}</p>
        <div class="geo-popup__actions">
          <button id="geo-redirect" class="geo-btn geo-btn--primary">${buttonLabel}</button>
          <button id="geo-dismiss" class="geo-btn geo-btn--secondary">Stay here</button>
        </div>
      </div>
    `;
    document.body.appendChild(popup);

    const style = document.createElement('style');
    style.textContent = `
      #geo-popup { position: fixed; inset: 0; z-index: 9999; display:flex; align-items:center; justify-content:center; font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial; }
      .geo-popup__overlay { position:absolute; inset:0; background: rgba(0,0,0,0.4); }
      .geo-popup__content { position: relative; background:#fff; padding:1.4rem 1.6rem; border-radius:12px; text-align:center; max-width:400px; width: calc(100% - 40px); box-shadow: 0 6px 30px rgba(0,0,0,0.18); z-index:10000; }
      .geo-popup__close { position:absolute; top:8px; right:10px; background:none; border:none; font-size:26px; line-height:1; cursor:pointer; color:#777; padding:4px; transition: transform 0.2s ease, color 0.2s ease; }
      .geo-popup__close:hover { color:#111; transform: scale(1.15); }
      .geo-popup__message { margin:0 0 12px 0; font-size:15px; color:#111; }
      .geo-popup__actions { display:flex; justify-content:center; gap:20px; margin-top:6px; }
      .geo-btn { border:none; cursor:pointer; border-radius:100px; padding:0.6rem 1.2rem; font-size:14px; min-width:120px; transition: all 0.25s ease; }
      .geo-btn--primary { background:#000; color:#fff; }
      .geo-btn--primary:hover { background:#333; }
      .geo-btn--secondary { background:#f1f1f1; color:#111; }
      .geo-btn--secondary:hover { background:#e2e2e2; }
      @media (max-width:420px) { .geo-popup__content { padding:1rem; } .geo-popup__actions { flex-direction:column; gap:12px; } .geo-btn { min-width:auto; width:100%; } }
    `;
    document.head.appendChild(style);

    const overlay = popup.querySelector('.geo-popup__overlay');
    const closeBtn = popup.querySelector('.geo-popup__close');
    const redirectBtn = document.getElementById('geo-redirect');
    const dismissBtn = document.getElementById('geo-dismiss');

    function closePopup() {
      const el = document.getElementById('geo-popup');
      if (el) el.remove();
    }

    redirectBtn.addEventListener('click', () => window.location.href = redirectUrl);
    dismissBtn.addEventListener('click', closePopup);
    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);

    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') {
        closePopup();
        document.removeEventListener('keydown', onKey);
      }
    });
  }

  // --- Main Logic with 1-minute localStorage cooldown per domain ---
  document.addEventListener('DOMContentLoaded', () => {
    const tz = getTimezone();
    if (!tz) return;

    const now = Date.now();
    const host = window.location.hostname;

    // Retrieve stored data
    const stored = localStorage.getItem('geo_popup_data');
    let lastShown = 0;
    let lastDomain = '';
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        lastShown = parsed.timestamp || 0;
        lastDomain = parsed.domain || '';
      } catch(e) {}
    }

    // Only show if more than cooldown has passed or different domain
    if (now - lastShown < COOLDOWN_MS && lastDomain === host) return;

    const country = countryFromTimezone(tz);
    const isAU_NZ = AU_TIMEZONES.includes(tz) || NZ_TIMEZONES.includes(tz);

    let msgHtml, buttonLabel, redirectUrl;

    if (isAU_NZ && host === DOMAIN_GLOBAL) {
      msgHtml = `It looks like you’re visiting from <strong>${country}</strong>?`;
      buttonLabel = 'Go to AU/NZ store';
      redirectUrl = `https://${DOMAIN_AU_NZ}${window.location.pathname}${window.location.search}`;
    } else if (!isAU_NZ && host === DOMAIN_AU_NZ) {
      msgHtml = `It looks like you’re visiting from <strong>outside AU/NZ</strong>?`;
      buttonLabel = 'Go to Global store';
      redirectUrl = `https://${DOMAIN_GLOBAL}${window.location.pathname}${window.location.search}`;
    } else {
      return; // Correct store
    }

    createPopup(msgHtml, buttonLabel, redirectUrl);

    // Save timestamp and domain in localStorage for cooldown and debugging
    localStorage.setItem('geo_popup_data', JSON.stringify({
      timestamp: now,
      domain: host
    }));

    // Debug log
    console.log('Geo popup shown:', { timestamp: now, domain: host });
  });
})();
